<!-- Header -->
<app-header></app-header>

<!-- Main content -->
<div
  class="px-6 xl:px-20 py-10 text-gray-800 flex flex-col justify-center items-center"
>
  <div class="max-w-7xl">
    <!-- About Section -->
    <div class="text-center mb-10">
      <div class="flex w-full items-center justify-center gap-4 py-8">
        <div class="w-16 h-[3px] bg-[#00D5BE]"></div>

        <h1 class="text-4xl font-bold text-gray-800">
          {{ "ABOUT_PAGE.TITLE" | translate }}
        </h1>

        <div class="w-16 h-[3px] bg-[#00D5BE]"></div>
      </div>
      <div
        class="text-start rounded-2xl shadow-xl mx-auto text-gray-700 leading-relaxed p-8 border"
      >
        {{ "ABOUT_PAGE.DESCRIPTION" | translate }}
      </div>
    </div>

    <!-- Mission Section -->
    <div
      class="bg-[linear-gradient(90deg,#009689,#009966)] text-white rounded-2xl shadow-xl p-10 text-center mb-14 border border-transparent"
    >
      <h2 class="text-3xl font-semibold mb-2">
        {{ "ABOUT_PAGE.MISSION.TITLE" | translate }}
      </h2>
      <p class="max-w-3xl mx-auto">
        {{ "ABOUT_PAGE.MISSION.SUBTITLE" | translate }}
      </p>
    </div>

    <!-- Why Choose Us Section -->
    <div class="mb-14">
      <h2 class="text-3xl font-bold text-center mb-8 text-black">
        {{ "ABOUT_PAGE.WHY_CHOOSE_US.TITLE" | translate }}
      </h2>
      <div class="grid md:grid-cols-2 gap-6 mx-auto">
        <!-- Licensed & Trusted -->
        <div
          class="flex items-center gap-3 p-4 bg-white shadow-xl rounded-2xl border"
        >
          <img
            src="assets/icons/about-shield.svg"
            [alt]="'ABOUT_PAGE.WHY_CHOOSE_US.LICENSED.ALT' | translate"
          />
          <div class="flex flex-col items-start gap-2">
            <h3 class="font-bold text-lg">
              {{ "ABOUT_PAGE.WHY_CHOOSE_US.LICENSED.TITLE" | translate }}
            </h3>
            <p class="text-gray-700">
              {{ "ABOUT_PAGE.WHY_CHOOSE_US.LICENSED.DESCRIPTION" | translate }}
            </p>
          </div>
        </div>

        <!-- Multiple Insurance Partners -->
        <div
          class="flex items-center gap-3 p-4 bg-white shadow-xl rounded-2xl border"
        >
          <img
            src="assets/icons/about-insurance-partner.svg"
            [alt]="'ABOUT_PAGE.WHY_CHOOSE_US.PARTNERS.ALT' | translate"
          />
          <div class="flex flex-col items-start gap-2">
            <h3 class="font-bold text-lg">
              {{ "ABOUT_PAGE.WHY_CHOOSE_US.PARTNERS.TITLE" | translate }}
            </h3>
            <p class="text-gray-700">
              {{ "ABOUT_PAGE.WHY_CHOOSE_US.PARTNERS.DESCRIPTION" | translate }}
            </p>
          </div>
        </div>

        <!-- SME Focused -->
        <div
          class="flex items-center gap-3 p-4 bg-white shadow-xl rounded-2xl border"
        >
          <img
            src="assets/icons/about-sme-focused.svg"
            [alt]="'ABOUT_PAGE.WHY_CHOOSE_US.SME.ALT' | translate"
          />
          <div class="flex flex-col items-start gap-2">
            <h3 class="font-bold text-lg">
              {{ "ABOUT_PAGE.WHY_CHOOSE_US.SME.TITLE" | translate }}
            </h3>
            <p class="text-gray-700">
              {{ "ABOUT_PAGE.WHY_CHOOSE_US.SME.DESCRIPTION" | translate }}
            </p>
          </div>
        </div>

        <!-- Smart Comparison -->
        <div
          class="flex items-center gap-3 p-4 bg-white shadow-xl rounded-2xl border"
        >
          <img
            src="assets/icons/about-comparison.svg"
            [alt]="'ABOUT_PAGE.WHY_CHOOSE_US.COMPARISON.ALT' | translate"
          />
          <div class="flex flex-col items-start gap-2">
            <h3 class="font-bold text-lg">
              {{ "ABOUT_PAGE.WHY_CHOOSE_US.COMPARISON.TITLE" | translate }}
            </h3>
            <p class="text-gray-700">
              {{
                "ABOUT_PAGE.WHY_CHOOSE_US.COMPARISON.DESCRIPTION" | translate
              }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Our Values Section -->
    <div class="mb-14">
      <h2 class="text-3xl font-bold text-center mb-8 text-black">
        {{ "ABOUT_PAGE.VALUES.TITLE" | translate }}
      </h2>
      <div class="grid sm:grid-cols-2 md:grid-cols-4 gap-6 mx-auto">
        <!-- Customer First -->
        <div
          class="bg-white shadow-xl rounded-2xl border p-6 text-center flex flex-col items-center gap-2"
        >
          <img
            src="assets/icons/about-customer-first.svg"
            [alt]="'ABOUT_PAGE.VALUES.CUSTOMER_FIRST.ALT' | translate"
          />
          <h3 class="font-bold text-lg">
            {{ "ABOUT_PAGE.VALUES.CUSTOMER_FIRST.TITLE" | translate }}
          </h3>
          <p class="text-gray-700 text-sm">
            {{ "ABOUT_PAGE.VALUES.CUSTOMER_FIRST.DESCRIPTION" | translate }}
          </p>
        </div>

        <!-- Transparency -->
        <div
          class="bg-white shadow-xl rounded-2xl border p-6 text-center flex flex-col items-center gap-2"
        >
          <img
            src="assets/icons/about-transparency.svg"
            [alt]="'ABOUT_PAGE.VALUES.TRANSPARENCY.ALT' | translate"
          />
          <h3 class="font-bold text-lg">
            {{ "ABOUT_PAGE.VALUES.TRANSPARENCY.TITLE" | translate }}
          </h3>
          <p class="text-gray-700 text-sm">
            {{ "ABOUT_PAGE.VALUES.TRANSPARENCY.DESCRIPTION" | translate }}
          </p>
        </div>

        <!-- Excellence -->
        <div
          class="bg-white shadow-xl rounded-2xl border p-6 text-center flex flex-col items-center gap-2"
        >
          <img
            src="assets/icons/about-excellence.svg"
            [alt]="'ABOUT_PAGE.VALUES.EXCELLENCE.ALT' | translate"
          />
          <h3 class="font-bold text-lg">
            {{ "ABOUT_PAGE.VALUES.EXCELLENCE.TITLE" | translate }}
          </h3>
          <p class="text-gray-700 text-sm">
            {{ "ABOUT_PAGE.VALUES.EXCELLENCE.DESCRIPTION" | translate }}
          </p>
        </div>

        <!-- Efficiency -->
        <div
          class="bg-white shadow-xl rounded-2xl border p-6 text-center flex flex-col items-center gap-2"
        >
          <img
            src="assets/icons/about-efficiency.svg"
            [alt]="'ABOUT_PAGE.VALUES.EFFICIENCY.ALT' | translate"
          />
          <h3 class="font-bold text-lg">
            {{ "ABOUT_PAGE.VALUES.EFFICIENCY.TITLE" | translate }}
          </h3>
          <p class="text-gray-700 text-sm">
            {{ "ABOUT_PAGE.VALUES.EFFICIENCY.DESCRIPTION" | translate }}
          </p>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div
      class="bg-teal-100 rounded-2xl p-10 text-center border border-2 border-teal-200 shadow-xl"
    >
      <h2 class="text-2xl font-bold mb-3 text-black">
        {{ "ABOUT_PAGE.CTA.TITLE" | translate }}
      </h2>
      <p class="text-gray-700 mb-6">
        {{ "ABOUT_PAGE.CTA.SUBTITLE" | translate }}
      </p>
      <div class="flex justify-center gap-4">
        <button
          class="bg-[#009689] text-white px-6 py-2 rounded-lg hover:bg-[#00BBA7] transition"
          (click)="openKeyClockLogin()"
        >
          {{ "ABOUT_PAGE.CTA.GET_STARTED_BUTTON" | translate }}
        </button>
        <a href="/contact">
          <button
            class="border border-[#009689] text-[#009689] px-6 py-2 rounded-lg hover:bg-[#009689] hover:text-white transition bg-white"
          >
            {{ "ABOUT_PAGE.CTA.CONTACT_US_BUTTON" | translate }}
          </button>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<app-footer layout="slim"></app-footer>
